<template>
  <div class="wrap padding-top-layout">
    <div class="wrap__block">
      <div class="wrap__block__header wrap__header">
        <div class="wrap__block__header__content">
          <span>{{ $t("facility_management.label_facility_management") }}</span>
          <div class="helper-icon">
            <img
              :src="getSettingIcon('helper-icon.svg')"
              @mouseover="changeTooltipImage($event)"
              @mouseleave="changeTooltipImage($event, 'mouseleave')"
              alt=""
            />
            <div v-if="showTooltip" class="helper-icon tooltip" v-html="$t('facility_management.tooltip_facility_management')"></div>
          </div>
        </div>
      </div>
      <div class="wrap__status">
        <div class="wrap__status__item">
          <img src="@/assets/icons/clock.svg" alt="" />
          <div class="wrap__status__item__wrap">
            <p>{{$t('common.last_update')}}</p>
            <p>{{ dateTimeFormat(statusUpdate.time) }}</p>
          </div>
        </div>
        <div class="wrap__status__item">
          <img src="@/assets/icons/userTable.svg" alt="" />
          <div class="wrap__status__item__wrap">
            <p>{{$t('common.updated_by')}}</p>
            <p>{{ statusUpdate.user || "" }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="category-table main-table custom-table facility-table"
      :class="[isFullScreen && 'full-screen', isExpand ? 'expanded' : 'no-expanded']"
    >
      <data-table
        v-show="isGetLayout"
        :data-source="branchList"
        :init-grid="initializeGrid"
        :grid-columns="gridColumns"
        :totalData="totalData"
        :rowFocus="2"
        :isHasData="isHasData"
        :cellInput="cellInput"
        :allowRightClick="true"
        @changeFullScreen="onChangeFullScreen"
        @onHandleActionTable="checkValidationData"
        @flexGridInitialDone="onFlexGridInitialDone"
        @changeTextToIdInSpecialPattern="handleChangeTextToIdInSpecialPattern"
        @updateAutoFill="checkTableChangeData"
      />
    </div>
    <dialog-popup
      :dialog="dialogPopup"
      :message="dialogMessage"
      @submit="() => checkboxHandler(false)"
      @close="closePopup"
    />
    <error-popup :dialog="dialogErrorPopup" :message="errorMessage" @submit="handleCloseDialogError" />
    <QuestionPopup v-if="!dialogNotification" :dialog="isShowUsedFacilityPopup" :message="usedFacility" @close="handleClosePopupUsedFacility" @submit="handleSubmitFacility" />
    <notification-popup :dialog="dialogNotification" :message="messageSavedChange" @submit="dialogNotification = false" />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  getListBranchApi,
  updateBranchApi,
  createBranchApi,
  updateBranchLayerApi,
  getListOrganizationalApi,
  updateBranchAttributeApi
} from "@/api/facility";
import { Tooltip, PopupPosition, CollectionView } from "@mescius/wijmo";
import * as wjGrid from "@mescius/wijmo.grid";
import * as wjcCore from "@mescius/wijmo";
import { AutoComplete, ComboBox } from "@mescius/wijmo.input";
import DialogPopup from "@/components/dialogs/question-popup";
import ErrorPopup from "@/components/dialogs/error-popup.vue";
import NotificationPopup from "@/components/dialogs/notification-popup.vue";
import DataTable from "@/components/category/data-table";
import { ROUTES } from "@/router/constants";
import { validateMaximumCharactor, validateBlankRowData } from "@/utils/validate";
import { formatDateTime } from "@/utils/datetimeFormat";
import { toolTipCustom } from "@/utils/tooltipCustom";
import { KEYS_CODE } from "@/constants/keyboard";
import { BLANK_ID } from "@/constants/registerData";
import debounce from "lodash/debounce";
import { UndoStack } from "@mescius/wijmo.undo";
import { GridEditAction } from "../managements/wijmo-extends";
import { batchReplacementViewCollection, emptyPromise } from "@/concerns/registerData/wijmo.helper";
import QuestionPopup from '@/components/dialogs/question-popup.vue';
import { getWidthByTextContent, setMinMaxSizeColumns } from '@/utils/calcTextWidth';
import { convertNestedFullWidthToHalfWidth } from '@/utils/convertHalfWidth'
import { $_helper_isNumberType } from '@/concerns/newRegisterData/wijmo.helper';
export default {
  data() {
    return {
      flex                : null,
      gridColumns         : [],
      dialogPopup         : false,
      dialogMessage       : this.$t('facility_management.description_dialog_message'),
      dialogCancelBtn     : false,
      check_status        : null,
      hdrTips             : new Tooltip({
        position   : PopupPosition.Above,
        showAtMouse: true,
        showDelay  : 600,
        cssClass   : "hdr-tip"
      }),
      branchList          : null,
      branchData          : [],
      listOrganizational  : [],
      idsUpdate           : [],
      dataRedo            : [],
      statusUpdate        : {
        time: null,
        user: null
      },
      totalData           : null,
      restoreSelection    : null,
      undoStack           : null,
      canUndo             : false,
      canRedo             : false,
      actionCount         : 0,
      stackUndoWhenUncheck: null,
      eventChangeStatus   : null,
      showTooltip         : false,
      listLayers          : [],
      layersEnable        : [],
      layerObject         : null,
      isGetLayout         : false,
      isEdit              : false,
      temp                : null,
      text                : null,
      currentlyCol        : {},
      limitBranch         : null,
      layersNotVisible    : [],
      dialogErrorPopup    : false,
      errorMessage        : "",
      listOriginalData    : [],
      dialogNotification: false,
      cellInput: [
        'organizational_division',
        'business_name',
        'company_name',
        'country',
        'layer_3',
        'layer_4',
        'layer_5',
        'layer_6',
      ],
      celEnabel: [],
      isEditDataTable: 0,
      flexGridBranch: null,
      isShowUsedFacilityPopup: false,
      submitDataError: {},
      usedFacility: this.$t('popup.popup_used_facility'),
      listOriginData: [],
      isDataError: false
    };
  },

  components: {
    DataTable,
    DialogPopup,
    ErrorPopup,
    NotificationPopup,
    QuestionPopup
  },

  computed: {
    ...mapState("userData", ["currentUser"]),
    ...mapState("commonApp", ["loadMore", "isFilter", "isExpand", "statusAction"]),
    ...mapState("actionsTable", ["startAction"]),
    ...mapState("actionsTable", ["dataAction"]),
    ...mapState("registerData", ["isFullScreen"]),

    isHasData() {
      return this.isEditDataTable || this.canUndo || this.canRedo;
    },
    messageSavedChange() {
      return this.$t('facility_management.message_saved_changes')
    },
    getObjOrigination() {
      let data = {}
      this.listOrganizational?.forEach(item => {
        if (!data[item.value]) {
          data[item.value] = {...item}
        }
      })
      return data
    },
    isProductPage() {
      return this.$route.name === "ProductsFacility";
    },
    breadCrumbItems() {
      return [
        {
          text    : this.$t('facility_management.hyperlink_home'),
          disabled: false,
          href    : this.isProductPage ? `${ROUTES.PRODUCTS_EMISSION}/${ROUTES.PRODUCT_DASHBOARD}` : ROUTES.HOME_DASHBOARD
        },
        {
          text    : this.$t('facility_management.hyperlink_setting'),
          disabled: false,
          href    : this.isProductPage ? `${ROUTES.PRODUCTS_EMISSION}${ROUTES.SETTING}` : ROUTES.SETTING
        },
        {
          text    : this.$t('facility_management.label_facility_management'),
          disabled: true,
          href    : this.isProductPage ? `${ROUTES.PRODUCTS_EMISSION}${ROUTES.FACILITY_MANAGEMENT}` : ROUTES.FACILITY_MANAGEMENT
        }
      ]
    }
  },

  async mounted() {
    this.actionUpdateIsLoading(true)
    this.updateBreadCrumb(this.breadCrumbItems);
    this.gridColumns                    = this.getGridColumns();
    const listOrganizationalApiResponse = await getListOrganizationalApi();
    this.getListOrganization(listOrganizationalApiResponse.data);
    this.isGetLayout = false;
    await this.getBranchList();
    this.createUndoStack();
    this.$nextTick(() => {
      this.actionUpdateIsLoading(false)
    })
    this.celEnabel = ['organizational_division', 'company_name']
  },

  watch: {
    startAction(newValue, _) {
      if (newValue.undo) {
        this.undoStack.undo();
      } else if (newValue.redo) {
        this.undoStack.redo();
      }
    },

    canUndo(newValue) {
      this.actionUpdateStatusBtn({
        undo: newValue,
        redo: this.canRedo
      });
    },

    canRedo(newValue) {
      this.actionUpdateStatusBtn({
        undo: this.canUndo,
        redo: newValue
      });
    }
  },

  methods: {
    ...mapActions("commonApp", ["updateBreadCrumb", "updateStatusAction", "actionUpdateIsLoading"]),
    ...mapActions("actionsTable", ["actionUpdate", "actionUpdateStatusBtn"]),
    ...mapActions("registerData", ["actionUpdateIsFullScreen"]),
    getWidthByText(string) {
      let text = document.createElement("span");
      document.body.appendChild(text);
      text.style.width      = "auto";
      text.style.position   = "absolute";
      text.style.whiteSpace = "no-wrap";
      text.style.font       = "Source Han Sans";
      text.style.fontSize   = 13 + "px";
      text.innerHTML        = string;
      const width           = text.clientWidth;
      document.body.removeChild(text);
      return width + 30 + 24 + 34 + 24; // width of button in header
    },
    handleRowActionType({
                          grid,
                          attribute,
                          layer,
                          showHideRow
                          // editRow,
                        }) {
      grid.hostElement.addEventListener("click", (e) => {
        let action    = e.target.getAttribute(attribute);
        let ht        = grid.hitTest(e);
        const payload = {
          contractor_id: layer.contractor_id,
          status       : layer.status,
          id           : layer.id,
          layer_name   : layer.layer_name?.length > 255 ? layer.layer_name.slice(0, 255) : layer.layer_name,
          layer_index  : layer.layer_index
        };

        if (
          (!action && ht.panel.cellType === wjGrid.CellType.Cell && this.isEdit) ||
          (!action && ht.panel.cellType === wjGrid.CellType.RowHeader && this.isEdit)
        ) {
          this.branchList.beginUpdate();
          if (attribute === this.currentlyCol?.layer_index && !(this.text === null || this.text.match(/^ *$/) !== null)) {
            grid.columns[this.temp].header = this.text;
            grid.columns[this.temp].width  = this.getWidthByText(this.text);

            const index = this.listLayers.findIndex(item => item.id === this.layerObject.id);

            this.listLayers[index].layer_name = this.text;

            this.updateBranchLayer({
              ...this.layerObject,
              layer_name: this.text,
              status    : this.layerObject.status ? 1 : 0
            });
            this.text = null;
          }
          this.branchList.endUpdate();
        } else if (!action) {
          return;
        }

        if (ht.panel.cellType == wjGrid.CellType.ColumnHeader && action === "editRow") {
          let htCol         = ht.col;
          let cell          = grid.columnHeaders.getCellElement(ht.row, ht.col);
          this.currentlyCol = payload;
          this.temp         = ht.col;
          this.isEdit       = true;
          this.layerObject  = payload;
          grid.columns[ht.col].edit = true,

            grid.refresh();
          let inputEle = cell.querySelector("input");
          if (inputEle) {
            inputEle.focus();
            inputEle.addEventListener("blur", (e) => {
              grid.columns[ht.col].header = inputEle.value;

              if (!/^ *$/.test(inputEle.value)) {
                const newVal = inputEle.value?.length > 255 ? inputEle.value.slice(0, 255) : inputEle.value;
                this.updateBranchLayer({
                  ...payload,
                  layer_name: newVal,
                  status    : payload.status ? 1 : 0
                });
                grid.columns[htCol].width         = this.getWidthByText(newVal);
                grid.columns[htCol].header        = newVal;
                const index                       = this.listLayers.findIndex(item => item.id === payload.id);
                this.listLayers[index].layer_name = newVal;
                const item                        = this.listLayers.find(item => item.id === payload.id && item.layerInvisible);
                if (item) {
                  const existIndex                             = this.layersNotVisible.findIndex(item => item.id === payload.id);
                  this.layersNotVisible[existIndex].layer_name = newVal;
                }
              } else {
                const index                = this.listLayers.findIndex(item => item.id === payload.id);
                grid.columns[htCol].header = this.listLayers[index].layer_name;
                grid.columns[htCol].width  = this.getWidthByText(this.listLayers[index].layer_name);
              }

              grid.columns[htCol].edit = false;
              grid.refresh();
            });
          }
        } else if (action === "showHideRow") {
          var data = grid.rows[ht.row].dataItem;
          this.updateBranchLayer({
            ...payload,
            status: payload.status ? 0 : 1
          });
          showHideRow && showHideRow(data, payload);
        }
      });
    },
    handleRowActionTypeLayerNotVisible({
                                         grid,
                                         attribute,
                                         layer,
                                         showHideRowLayerNotVisible
                                         // editRow,
                                       }) {
      grid.hostElement.addEventListener("click", (e) => {
        let action    = e.target.getAttribute(attribute);
        let ht        = grid.hitTest(e);
        const payload = {
          contractor_id: layer.contractor_id,
          status       : layer.status,
          id           : layer.id,
          layer_name   : layer.layer_name?.length > 255 ? layer.layer_name.slice(0, 255) : layer.layer_name,
          layer_index  : layer.layer_index
        };

        if (
          (!action && ht.panel.cellType === wjGrid.CellType.Cell && this.isEdit) ||
          (!action && ht.panel.cellType === wjGrid.CellType.RowHeader && this.isEdit)
        ) {
          this.branchList.beginUpdate();
          if (attribute === this.currentlyCol?.layer_index && !(this.text === null || this.text.match(/^ *$/) !== null)) {
            grid.columns[this.temp].header = this.text;
            grid.columns[this.temp].width  = this.getWidthByText(this.text);

            const index = this.layersNotVisible.findIndex(item => item.id === this.layerObject.id);

            this.layersNotVisible[index].layer_name = this.text;
            this.updateBranchLayer({
              ...this.layerObject,
              layer_name: this.text,
              status    : this.layerObject.status ? 1 : 0
            });
            this.text = null;
          }
          this.branchList.endUpdate();
        } else if (!action) {
          return;
        }

        if (ht.panel.cellType == wjGrid.CellType.ColumnHeader && action === "editRow") {
          let htCol         = ht.col;
          let cell          = grid.columnHeaders.getCellElement(ht.row, ht.col);
          this.currentlyCol = payload;
          this.temp         = ht.col;
          this.isEdit       = true;
          this.layerObject  = payload;
          grid.columns[ht.col].edit = true,
            grid.refresh();
          let inputEle = cell.querySelector("input");
          if (inputEle) {
            inputEle.focus();
            inputEle.addEventListener("blur", (e) => {
              grid.columns[ht.col].header = inputEle.value;

              if (!/^ *$/.test(inputEle.value)) {
                const newVal = inputEle.value?.length > 255 ? inputEle.value.slice(0, 255) : inputEle.value;
                this.updateBranchLayer({
                  ...payload,
                  layer_name: newVal,
                  status    : payload.status ? 1 : 0
                });
                grid.columns[htCol].width         = this.getWidthByText(newVal);
                grid.columns[htCol].header        = newVal;
                const index                       = this.listLayers.findIndex(item => item.id === payload.id);
                this.listLayers[index].layer_name = newVal;
                const item                        = this.listLayers.find(item => item.id === payload.id && item.layerInvisible);
                if (item) {
                  const existIndex                             = this.layersNotVisible.findIndex(item => item.id === payload.id);
                  this.layersNotVisible[existIndex].layer_name = newVal;
                }
              } else {
                const index                = this.listLayers.findIndex(item => item.id === payload.id);
                grid.columns[htCol].header = this.listLayers[index].layer_name;
                grid.columns[htCol].width  = this.getWidthByText(this.listLayers[index].layer_name);
              }
              grid.columns[htCol].edit = false;
              grid.refresh();
            });
          }
        } else if (action === "showHideRow") {
          var data = grid.rows[ht.row].dataItem;
          this.updateBranchLayer({
            ...payload,
            status: payload.status ? 0 : 1
          });
          showHideRowLayerNotVisible && showHideRowLayerNotVisible(data, payload);
        }
      });
    },
    initializeGrid(flexgrid) {
      this.flex = flexgrid;

      flexgrid.scrollPositionChanged.addHandler(
        debounce((s, e) => {
          if (!this.$store.state.registerData.isFullScreen) {
            return;
          }

          if (s.viewRange.bottomRow >= s.rows.length - 1) {
            s.deferUpdate(() => {
              const lastClientId = flexgrid.itemsSource.itemCount;

              for (let index = 1; index <= 100; index++) {
                s.itemsSource.addNew(this.blankData(lastClientId + index));
              }

              s.itemsSource.commitNew();
              s.itemsSource.clearChanges();
            });
          }
        }, 100)
      );
      document.addEventListener("keydown", (e) => {
        if (
          (e.metaKey || e.ctrlKey) &&
          [
            KEYS_CODE.DOWN_ARROW,
            KEYS_CODE.UP_ARROW,
            KEYS_CODE.LEFT_ARROW,
            KEYS_CODE.RIGHT_ARROW,
            KEYS_CODE.ENTER
          ].includes(e.keyCode)
        ) {
          e.preventDefault();
        }
      });

      flexgrid.hostElement.addEventListener(
        "keydown",
        (e) => {
          // console.log('keydown: ', e);
          if (e.metaKey || e.ctrlKey) {
            if (e.keyCode === KEYS_CODE.DOWN_ARROW) {
              const currentSelection = flexgrid.selection;
              const cellRange        = new wjGrid.CellRange(flexgrid.rows.length - 1, currentSelection.col);
              flexgrid.selection     = cellRange;

              // re-select after add more
              setTimeout(() => {
                flexgrid.selection = cellRange;
              }, 200);
            } else if (e.keyCode === KEYS_CODE.UP_ARROW) {
              const currentSelection = flexgrid.selection;
              const cellRange        = new wjGrid.CellRange(0, currentSelection.col);
              flexgrid.selection     = cellRange;
            } else if (e.keyCode === KEYS_CODE.RIGHT_ARROW) {
              const currentSelection = flexgrid.selection;
              const cellRange        = new wjGrid.CellRange(currentSelection.row, flexgrid.columns.length - 1);
              flexgrid.selection     = cellRange;
            } else if (e.keyCode === KEYS_CODE.LEFT_ARROW) {
              const currentSelection = flexgrid.selection;
              const cellRange        = new wjGrid.CellRange(currentSelection.row, 2);
              flexgrid.selection     = cellRange;
            }
          }

          if (e.keyCode === KEYS_CODE.ENTER) {
            if (flexgrid.selection.row === flexgrid.rows.length - 1) {
              const lastClientId = flexgrid.itemsSource.itemCount;

              flexgrid.deferUpdate(() => {
                flexgrid.itemsSource.addNew(this.blankData(lastClientId + 1));
                flexgrid.itemsSource.commitNew();
                flexgrid.itemsSource.clearChanges();
              });
            }
          }
        },
        false
      );

      flexgrid?.cellEditEnded.addHandler((s, e) => {
        this.checkTableChangeData();
        const { row } = e.range;
        const view = s.collectionView;
        const source = view.sourceCollection;
        const currentItem = source[row] || {};
        this.handleConvertFullWidthToHaftWidth(s, e);
        if(this.isItemActive(currentItem)) {
          currentItem.status = true
        }

        if (
          s.columns[e.col].binding !== "organizational_division" ||
          s.columns[e.col].binding !== "organizational_scope_name"
        ) {
          return;
        }
      });

      flexgrid?.beginningEdit.addHandler((s, e) => {
        let column        = s.columns[e.col];
        let rowValue      = s.rows[e.row]._data;
        this.check_status = rowValue;
        if (column.cssClass?.includes("auto-increment") || column.binding === "add_column") {
          e.cancel = true;
        }
        if (column.binding !== "status") {
          return;
        }

        this.stackUndoWhenUncheck = new GridEditAction(s, e);
        this.handleCheckBox(rowValue);
        e.cancel = true;
      });

      flexgrid?.formatItem.addHandler((s, e) => {
        const colBinding             = e.panel.columns[e.col].binding;
        const keyBinding             = this.listLayers.map((layer) => layer.binding);
        const layersInvisibleBinding = this.layersNotVisible.map((layer) => layer.binding);
        const arr                    = [
          "company_name",
          "business_name",
          "name",
          "organizational_division",
          "country",
          ...keyBinding,
          ...layersInvisibleBinding,
          "status",
          "add_column"
        ];
        if (e.panel == s.columnHeaders) {
          if (!arr.includes(colBinding)) {
            return null;
          }
          if (colBinding === "company_name") {
            toolTipCustom(e, "t1", this.$t('facility_management.tooltip_company_name'), this.hdrTips);
          }
          if (colBinding === "organizational_division") {
            toolTipCustom(
              e,
              "t3",
              this.$t('facility_management.tooltip_organizational_division'),
              this.hdrTips
            );
          }
          if (colBinding === "status") {
            toolTipCustom(
              e,
              "t10",
              this.$t('facility_management.tooltip_status'),
              this.hdrTips
            );
          }
          if (colBinding === "add_column") {
            e.cell.innerHTML = "<div class='add-layer'></div>" + e.cell.innerHTML;
            e.cell.innerHTML = e.cell.innerHTML.replace('<span class="wj-glyph-filter"></span>', '');
          }
          this.listLayers.map((layer) => {
            if (colBinding === layer.binding && !layer?.layerInvisible) {
              const findIsEnableRow = this.layersEnable.find((f) => f.id === layer.id);
              toolTipCustom(
              e,
              "t5",
              "",
              this.hdrTips
            );
              e.cell.innerHTML =
              `<div class="icon-right">
                <img class="edit-layer-name" src="${require("@/assets/icons/facility/editLayerName.svg")}" ${
                  layer.layer_index
                }="editRow" />
                <img class="switch-layer" src="${require(`@/assets/icons/facility/${
                  findIsEnableRow?.status ? "eyeOn.svg" : "eyeOff.svg"
                }`)}" ${layer.layer_index}="showHideRow"/>
              </div>${e.cell.innerHTML}`
            }
          });
          this.layersNotVisible.map((layer) => {
            if (colBinding === layer.binding) {
              toolTipCustom(
              e,
              "t5",
              "",
              this.hdrTips
            );
              e.cell.innerHTML =
              `<div class="icon-right">
                <img class="edit-layer-name" src="${require("@/assets/icons/facility/editLayerName.svg")}" ${
                  layer.layer_index
                }="editRow" />
                <img class="switch-layer" src="${require(`@/assets/icons/facility/${
                  layer?.status ? "eyeOn.svg" : "eyeOff.svg"
                }`)}" ${layer.layer_index}="showHideRow"/>
              </div>${e.cell.innerHTML}`
            }
          });

          if (e.panel !== s.columnHeaders) {
            return;
          }
          if (flexgrid.columns[e.col].edit) {
            let col           = e.panel.columns[e.col];
            let c             = e.col;
            s.columns[c].edit = false;
            let element       = document.createElement("div");
            element.setAttribute(
              "style",
              `width: 100%`
            );
            let comboBox = new ComboBox(element);

            comboBox.text = col.header;
            comboBox.textChanged.addHandler((s) => {
              this.text = comboBox._oldText?.length > 255 ? comboBox._oldText.slice(0, 255) : comboBox._oldText;
            });
            e.cell.innerHTML = "";
            e.cell.appendChild(comboBox.hostElement);
            wjcCore.addClass(e.cell, "my-header-cell");
          }
        }
      });

      flexgrid.hostElement.addEventListener("click", (e) => {
        if (e.target.className === "add-layer" && this.limitBranch > this.listLayers.length && this.statusAction) {
          this.updateStatusAction(false);
          let attributeBranchList = [];
          const layerIndex        = this.listLayers.length + 1;
          const attributeBranch   = {
            contractor_id: this.currentUser.user.contractor_id,
            layer_name   : this.$t('facility_management.table_layer', {layerIndex}),
            layer_index  : layerIndex,
            status       : "1"
          };
          attributeBranchList.push(attributeBranch);
          updateBranchAttributeApi({ data: Object.values(attributeBranchList) }).then((res) => {
            const recordInsert = res.record_insert[0];
            let binding        = `layer_${layerIndex}`;
            if (layerIndex === 1) {
              binding = "business_name";
            } else if (layerIndex === 2) {
              binding = "country";
            }
            this.listLayers.push({
              ...recordInsert,
              cssClass      : "",
              isReadOnly    : false,
              binding       : binding,
              layerInvisible: true
            });
            this.layersEnable.push({
              id    : recordInsert.id,
              status: recordInsert.status
            });
            flexgrid.columns.getColumn(binding).visible = true;
            const getIndex                              = this.layersNotVisible.findIndex((layer) => layer.binding === binding);
            if (getIndex >= 0) {
              this.layersNotVisible[getIndex].id = recordInsert.id;
            }
            this.updateStatusAction(true);
          }).catch((error) => {
            console.warn(error);
            this.updateStatusAction(true);
          });
        }
        if (e.target.className === "add-layer" && this.limitBranch <= this.listLayers.length) {
          this.dialogErrorPopup = true;
          this.errorMessage = this.$t('popup.popup_not_add_layer');
        }
      });
      flexgrid.pasted.addHandler((s, e) => {
        const { row, row2 } = e.range;
        const dataPasted = s.collectionView.sourceCollection.filter((item, index) => index >= row && index <= row2);
        dataPasted.forEach(rowItem => {
          if(this.isItemActive(rowItem)) {
            rowItem.status = true
          }
        })
        this.checkTableChangeData();
      });
      flexgrid.pastedCell.addHandler((s, e) => {
        const { col, row } = e.range;
        const binding = s.columns[col].binding;
        const cellData = s.getCellData(row, col, false);
        const currentItem = s.rows[row]?.dataItem || {};
        if (!['organizational_division', 'status'].includes(binding)) {
          currentItem[binding] = cellData?.trim();
        }
      });
    },
    handleConvertFullWidthToHaftWidth(s, e) {
      const { row, col } = e.range;
      let cellData = s.getCellData(row, col, false)?.toString();
      const isNumber = $_helper_isNumberType(cellData);
      cellData = cellData && isNumber ? cellData : convertNestedFullWidthToHalfWidth(cellData);
      s.setCellData(row, col, cellData?.trim(), false, true);
    },
    onEditRow(data, layer) {
      this.gridColumns = this.getGridColumns();
    },

    onShowHideRow(data, layer) {
      const index                       = this.listLayers.findIndex(item => item.id === layer.id);
      this.listLayers[index].cssClass   = layer.status ? "auto-increment" : "";
      this.listLayers[index].status     = !layer.status;
      this.listLayers[index].isReadOnly = layer.status;
      this.layersEnable                 = this.layersEnable.map((currentLayer) => {
        if (layer.id === currentLayer.id) {
          return {
            ...currentLayer,
            status: !currentLayer.status
          };
        }
        return currentLayer;
      });
      this.branchList.beginUpdate();
      const headerIndex                         = this.flex.columns.findIndex(item => item.index === layer.layer_index + 2);
      this.flex.columns[headerIndex].isReadOnly = layer.status;
      this.flex.columns[headerIndex].cssClass   = layer.status ? "auto-increment" : "";
      this.branchList.endUpdate();
    },

    onEditRowLayerNotVisible(data, layer) {
      this.gridColumns = this.getGridColumns();
    },

    onShowHideRowLayerNotVisible(data, layer) {
      const index                             = this.layersNotVisible.findIndex(item => item.id === layer.id);
      this.layersNotVisible[index].cssClass   = layer.status ? "auto-increment" : "";
      this.layersNotVisible[index].status     = !layer.status;
      this.layersNotVisible[index].isReadOnly = layer.status;
      this.branchList.beginUpdate();
      const headerIndex                         = this.flex.columns.findIndex(item => item.index === layer.layer_index + 2);
      this.flex.columns[headerIndex].isReadOnly = layer.status;
      this.flex.columns[headerIndex].cssClass   = layer.status ? "auto-increment" : "";
      this.branchList.endUpdate();
    },

    async updateBranchLayer(item) {
      try {
        const data        = [].concat(item);
        let res           = await updateBranchLayerApi({ data });
        this.statusUpdate = {
          time: res.latest_record.updated_at_latest,
          user: res.latest_record.user_updated
        };
      } catch (err) {
        console.log("[UPDATE ERR:]", { ...err });
      }
    },

    defineTable() {
      this.gridColumns = this.getGridColumns();
      this.initialView();

      this.$nextTick(() => {
        this.scrollToTop();
      });
    },

    emptyCell(item) {
      if (item === undefined || item === null) {
        return this.$t('validation.error_required_field');
      }
      return null;
    },

    getError(item, propName) {
      if (validateBlankRowData(item, ['organizational_division', 'company_name', 'business_name', 'country', 'layer_3', 'layer_4', 'layer_5', 'layer_6'])) {
        return null;
      }
      switch (propName) {
        case "organizational_division":
          return this.emptyCell(item[propName]);
        case "company_name":
          return validateMaximumCharactor(item[propName], 128);
        case "country":
        case "business_name":
        case "layer_3":
        case "layer_4":
        case "layer_5":
        case "layer_6":
          return item[propName] && validateMaximumCharactor(item[propName], 128);
      }
      return null;
    },
    getTextWidth(string) {
      return getWidthByTextContent(string) + 87; // 6 + 18 + 53 + 10 (6 = margin left tooltip, 18: width tooltip, 53: icon, 10: default number margin)
    },
    getGridColumns() {
      const mapLayers = this.listLayers.map((layer) => ({
        header      : layer.layer_name,
        binding     : layer.binding,
        minWidth    : this.getTextWidth(layer.layer_name),
        maxWidth    : 980,
        allowSorting: false,
        isRequired  : false,
        cssClass    : layer.cssClass,
        isReadOnly  : layer.isReadOnly,
        wordWrap    : true,
        cssClassAll : "single-row"
      }));
      const hiddenLayers = this.layersNotVisible.map((layer) => ({
        header      : layer.layer_name,
        binding     : layer.binding,
        minWidth    : 217,
        maxWidth    : 980,
        allowSorting: false,
        isRequired  : false,
        cssClass    : layer.cssClass,
        isReadOnly  : layer.isReadOnly,
        visible     : layer.visible,
        wordWrap    : true,
        cssClassAll : "single-row"
      }));
      return [
        {
          header      : "#",
          binding     : "id",
          allowSorting: false,
          isReadOnly  : true,
          visible     : false
        },
        {
          header      : this.$t('facility_management.table_organizational_division'),
          binding     : "organizational_division",
          minWidth    : getWidthByTextContent(this.$t('facility_management.table_organizational_division')) + 25,
          maxWidth    : 400,
          allowSorting: false,
          dataMap     : new wjGrid.DataMap(this.listOrganizational, "id", "value"),
          isRequired  : false,
          editor      : new AutoComplete(document.createElement("div"), {
            placeholder: this.$t('56_pattern.placeholder'),
            itemsSource      : this.listOrganizational,
            selectedValuePath: "id",
            displayMemberPath: "value"
          }),
          wordWrap    : true,
          cssClassAll : "single-row"
        },
        {
          header      : this.$t('facility_management.table_company_name'),
          binding     : "company_name",
          minWidth    : getWidthByTextContent(this.$t('facility_management.table_company_name')) + 25,
          maxWidth    : 980,
          allowSorting: false,
          isRequired  : false,
          wordWrap    : true,
          cssClassAll : "single-row"
        },
        ...mapLayers,
        ...hiddenLayers,
        {
          header: " ",
          binding: 'add_column',
          minWidth    : 160,
          maxWidth    : 400,
          allowSorting: false,
          isRequired  : false,
          cssClass : "auto-increment"
        },
        {
          header      : this.$t('facility_management.table_status'),
          binding     : "status",
          minWidth    : this.getWidthByText(this.$t('facility_management.table_status')),
          width       : '*',
          allowSorting: false,
          isRequired  : false,
          dataType    : "Boolean",
          wordWrap    : true,
          cssClassAll : "single-row"
        }
      ];
    },
    handleCheckBox(value) {
      if (value?.status) {
        this.dialogPopup     = true;
        this.dialogCancelBtn = true;
      } else {
        this.checkboxHandler(true);
      }
    },

    handleCloseDialogError() {
      if (this.errorMessage === this.$t('popup.popup_not_add_layer')) {
        this.dialogErrorPopup = false;
        return;
      }
      try {
        this.dialogErrorPopup = false;
        getListBranchApi({
          contractor_id: this.currentUser.user.contractor_id
        }).then((response) => {
          this.undoStack.clear();
          this.branchList = new CollectionView([...response.data], {
            trackChanges: true,
          });
          this.addBlankItemsToView(10);
          this.actionUpdateIsFullScreen(false);
          this.branchList.moveCurrentToPosition(-1);
          setMinMaxSizeColumns(this.flex, response.data);
        });
      } catch (error) {
        this.dialogErrorPopup = true;
      }
    },

    checkboxHandler(check) {
      if (this.check_status.id === undefined || !this.check_status.organizational_division || !this.check_status.company_name) {
        return;
      }
      this.isEditDataTable = true
      this.branchList.beginUpdate();
      this.branchList.currentItem.status = check;
      this.branchList.endUpdate();
      if (this.branchList.currentItem?.id && this.branchList.currentItem?.id !== BLANK_ID) {
        const existItem = this.branchList.itemsEdited.findIndex(item => item.id === this.branchList.currentItem?.id);
        if (existItem < 0) {
          this.branchList.itemsEdited.push(this.branchList.currentItem);
        }
      }
      if (this.stackUndoWhenUncheck) {
        this.undoStack.pushAction(this.stackUndoWhenUncheck);
        this.stackUndoWhenUncheck = null;
      }
      this.closePopup();
    },

    closePopup() {
      this.dialogPopup     = false;
      this.dialogCancelBtn = true;
    },

    getListOrganization(data) {
      data.forEach((item) => {
        this.listOrganizational.push({
          id   : item.id,
          value: item.type
        });
      });
    },

    dateTimeFormat(dateTime) {
      return formatDateTime(dateTime);
    },
    getSettingIcon(image) {
      if (image) {
        return require(`@/assets/icons/${image}`);
      }
      return "";
    },

    changeTooltipImage(event, type) {
      if (type === "mouseleave") {
        event.target.src                        = this.getSettingIcon("helper-icon.svg");
        event.target.parentElement.style.cursor = "default";
        this.showTooltip                        = false;
      } else {
        event.target.src                        = this.getSettingIcon("helper-icon_active.svg");
        event.target.parentElement.style.cursor = "pointer";
        this.showTooltip                        = true;
      }
    },
    blankData(clientRowId) {
      return {
        clientRowId            : clientRowId,
        id                     : BLANK_ID,
        company_name           : null,
        business_name          : null,
        layer_3                : null,
        layer_4                : null,
        layer_5                : null,
        layer_6                : null,
        organizational_division: null,
        country                : null,
        contractor_id          : null,
        status                 : null
      };
    },
    addBlankItemsToView(count) {
      const lastClientId = this.branchList.itemCount;
      for (let index = 1; index <= count; index++) {
        this.branchList.addNew(this.blankData(lastClientId + index));
      }

      this.branchList.commitNew();
      this.branchList.clearChanges();
    },
    scrollToTop() {
      if (!this.flex) {
        return;
      }

      let rc                   = this.flex.cells.getCellBoundingRect(0, 0, true);
      this.flex.scrollPosition = new wjcCore.Point(this.flex.scrollPosition.x, -rc.top);
    },
    initialView() {
      if (this.branchList) {
        this.branchData = this.branchList.items.filter((item) => item.id && item.id !== BLANK_ID);
      }

      this.branchList       = new CollectionView([...this.branchData], {
        trackChanges: true,
      });
      this.addBlankItemsToView(10);
      this.listOriginalData = JSON.parse(JSON.stringify(this.branchList.items));

      this.flex.columnGroups = this.gridColumns;
      this.branchList.currentItem = null;
      setMinMaxSizeColumns(this.flex, this.branchData);
      this.branchList.collectionChanged.addHandler(() => {
        this.branchList?.itemsAdded?.forEach((itemAdd) => {
          this.trimTextBeforeAddToTable(itemAdd);
          if(this.isItemActive(itemAdd)) {
            itemAdd.status = true
          }
        })
      })
    },
    // TODO
    isValidFacility(item) {
      if (
        !item?.organizational_division ||
        !item?.company_name ||
        item?.company_name?.length > 128 ||
        item?.country?.length > 128 ||
        item?.business_name?.length > 128 ||
        item?.layer_3?.length > 128 ||
        item?.layer_4?.length > 128 ||
        item?.layer_5?.length > 128 ||
        item?.layer_6?.length > 128
      ) {
        this.isDataError = true;
        return false;
      }
      return true;
    },
    onChangeFullScreen(isFullScreen) {
      if (isFullScreen) {
        this.addBlankItemsToView(100);
        this.scrollToTop();
      } else {
        // this.initialView();

        this.$nextTick(() => {
          this.scrollToTop();
        });
      }
    },
    onFlexGridInitialDone(flexgrid) {

      if (!flexgrid) {
        return;
      }
      this.flexgrid = flexgrid;

      this.canUndo = false;
      this.canRedo = false;

      const stateChanged = (e) => {
        this.canUndo = e.canUndo;
        this.canRedo = e.canRedo;
      };

      this.undoStack = new UndoStack(flexgrid, stateChanged);
    },
    getListLayerNotVisible(layerList) {
      const layerArr = ["business_name", "country", "layer_3", "layer_4", "layer_5", "layer_6"];
      layerArr.splice(0, layerList.length);
      const layerDataList = [];
      layerArr.map((layer, index) => {
        let binding = layer;
        let layerIndex = Number(layerList.length) + Number(index) + 1;
        let name    = this.$t('facility_management.table_layer', {layerIndex});
        layerDataList.push({
          contractor_id: this.currentUser.user.contractor_id,
          cssClass     : "",
          isReadOnly   : false,
          status       : true,
          visible      : false,
          layer_index  : Number(layerList.length) + Number(index) + 1,
          layer_name   : name,
          binding
        });
      });
      return layerDataList;
    },
    handleHeaderEvent() {
      // handle show/hide columns
      var editRow     = this.onEditRow.bind(this);
      var showHideRow = this.onShowHideRow.bind(this);
      var listLayers  = this.listLayers;
      listLayers.map((layer) => {
        this.handleRowActionType({
          grid     : this.flex,
          attribute: layer.layer_index,
          layer,
          editRow,
          showHideRow
        });
      });
      var editRowLayerNotVisible     = this.onEditRowLayerNotVisible.bind(this);
      var showHideRowLayerNotVisible = this.onShowHideRowLayerNotVisible.bind(this);
      this.layersNotVisible.map((layer) => {
        this.handleRowActionTypeLayerNotVisible({
          grid     : this.flex,
          attribute: layer.layer_index,
          layer,
          editRowLayerNotVisible,
          showHideRowLayerNotVisible
        });
      });
    },
    createUndoStack() {
      this.undoStack = new UndoStack("#undoable-table", {
        maxActions  : 50,
        stateChanged: (s) => {
          this.canUndo = s.canUndo;
          this.canRedo = s.canRedo;
        }
      });
    },
    checkValidationData() {
      this.branchList.getError = this.getError;
      this.submitData();
    },
    submitData() {
      let edited      = {};
      let editedBlank = {};
      let added       = {};

      this.branchList.itemsEdited.forEach((item, index) => {
        if (validateBlankRowData(item, ['organizational_division', 'company_name', 'business_name', 'country', 'layer_3', 'layer_4', 'layer_5', 'layer_6'])) {
          return;
        }
        let prepareBranch = this.preprocessPayloadData(item);
        if (!this.isValidFacility(prepareBranch)) {
          return;
        }
        const indexPayload = this.branchList.items.indexOf(item);
        if(indexPayload !== -1) {
          prepareBranch['index'] = indexPayload + 1;
        }
        if (item.id === BLANK_ID) {
          editedBlank[indexPayload] = prepareBranch;
        } else {
          edited[indexPayload] = prepareBranch;
        }
      });

      this.branchList.itemsAdded.forEach((branch, index) => {
        let itemCustom = this.preprocessPayloadData(branch);
        if (!this.isValidFacility(itemCustom)) {
          return;
        }
        const indexPayload = this.branchList.items.indexOf(branch);
        if(indexPayload !== -1) {
          itemCustom['index'] = indexPayload + 1;
        }
        added[index] = itemCustom;
      });

      if (this.isDataError) {
        // return if has error
        return;
      }
      this.isDataError = false;
      this.branchList.getError = null;
      // call api
      this.actionUpdateIsLoading(true)
      this.submitDataError = { data: Object.values(edited), always_update: true }
      const editedPromise = Object.values(edited).length ? updateBranchApi({ data: Object.values(edited) }).then(() => {
        this.listOriginalData  = JSON.parse(JSON.stringify(this.branchList.items));
        this.undoStack.clear();
        this.isEditDataTable = false
      })
      .catch((error) => {
        const errorCodeUncheckBranch = 'error_message.branches.branch_exist_tmp';
        const errorCode = error.code;
        if (errorCode === errorCodeUncheckBranch) {
          this.isShowUsedFacilityPopup = true;
        }
      }) : emptyPromise();

      const editedBlankPromise = Object.values(editedBlank).length ? createBranchApi({ data: Object.values(editedBlank) }).then((res) => {
        this.afterDataSuccess(this.branchList.itemsEdited, editedBlank, res);
      }).catch((error) => {
        console.warn(error);
        this.showLimitFacilities(error);
      }) : emptyPromise();

      const addedPromise = Object.values(added).length ? createBranchApi({ data: Object.values(added) }).then((res) => {
        this.afterDataSuccess(this.branchList.itemsAdded, added, res);
      }).catch((error) => {
        console.warn(error);
        this.showLimitFacilities(error);
      }) : emptyPromise();

      const isEmptyAdd = !Object.values(editedBlank).length && !Object.values(added).length && !Object.values(edited).length
      Promise.all([editedPromise, editedBlankPromise, addedPromise])
      .then(() => {
        if(!isEmptyAdd && !this.isShowUsedFacilityPopup && this.errorMessage !== this.$t('popup.popup_limit_facilities')) {
          this.dialogNotification = true;
        }
        this.undoStack.clear();
        this.isEditDataTable = false
        this.actionUpdateIsLoading(false)
        this.listOriginalData  = JSON.parse(JSON.stringify(this.branchList.sourceCollection));
      })
      .catch((error) => {
        console.warn(error);
        this.showLimitFacilities(error);
        this.actionUpdateIsLoading(false)
      });
    },
    afterDataSuccess(collection, items, response) {
      const addedReplacement = {
        id    : "id",
        status: "status",
      };
      this.statusUpdate      = {
        time: response?.latest_record?.updated_at_latest,
        user: response?.latest_record?.user_updated
      };
      this.branchList.deferUpdate(() => {
        batchReplacementViewCollection(collection, response.record_insert, Object.keys(items), addedReplacement);
        collection.length = 0;
      });
      // this.listOriginalData  = JSON.parse(JSON.stringify(this.branchList.items));
    },
    showLimitFacilities(error) {
      const errorCodeMaxLimitReached = 'error_message.branches.registration_limit';
      if (error.code === errorCodeMaxLimitReached) {
        this.dialogErrorPopup = true;
        this.errorMessage = this.$t('popup.popup_limit_facilities');
      }
    },
    isItemActive(item) {
      return this.celEnabel.every(key => item[key]) && (!item.id || item.id === BLANK_ID)
    },
    handleSubmitFacility() {
      this.isShowUsedFacilityPopup = false
      updateBranchApi(this.submitDataError).then(() => {
        this.listOriginalData  = JSON.parse(JSON.stringify(this.branchList.items));
        this.dialogNotification = true;
        this.undoStack.clear();
      })
    },
    async getBranchList() {
      await getListBranchApi({
        contractor_id: this.currentUser.user.contractor_id
      }).then((responseApiListBranch) => {
        this.listLayers       = [];
        this.listLayers       = responseApiListBranch?.layer.map((layer) => {
          let binding = `layer_${layer.layer_index}`;
          if (layer.layer_index === 1) {
            binding = "business_name";
          } else if (layer.layer_index === 2) {
            binding = "country";
          }
          return {
            ...layer,
            cssClass  : !layer.status ? "auto-increment" : "",
            isReadOnly: !layer.status,
            binding
          };
        }).sort((firstLayer, nextLayer) => firstLayer.id - nextLayer.id);
        this.layersEnable     = responseApiListBranch.layer?.map((layer) => ({
          status: layer.status,
          id    : layer.id
          // cssClass: !layer.status ? 'auto-increment' : ''
        }));
        this.limitBranch      = Number(responseApiListBranch.number_limit_branch);
        this.layersNotVisible = [];
        this.layersNotVisible = this.getListLayerNotVisible(responseApiListBranch?.layer);
        this.isGetLayout      = true;
        this.branchData       = responseApiListBranch.data?.map((item, index) => item && {
          ...item,
          index: index + 1
        });
        this.totalData        = this.branchData.length;
        this.statusUpdate     = {
          time: responseApiListBranch.updated_at_latest,
          user: responseApiListBranch.user_updated
        };
      }).catch(() => {
        this.isGetLayout = true;
      });
      this.defineTable(this.branchData);
      this.handleHeaderEvent();
    },
    async handleClosePopupUsedFacility() {
      this.isShowUsedFacilityPopup = false
      this.branchData = null
      this.branchList = null
      this.isGetLayout = false
      this.getBranchList()
    },
    checkTableChangeData() {
      setTimeout(() => {
        this.isEditDataTable = false;
        const itemsInView = ['organizational_division', 'business_name']
        this.branchList?.itemsEdited.some((item) => {
          const everyColumnsAreNull = itemsInView.every(
            (field) => item[field] === null || item[field] === '' || item[field] === undefined,
          );
          if (!everyColumnsAreNull) {
            this.isEditDataTable = true;
            return true;
          }
        });

        this.branchList?.itemsAdded.some((item) => {
          const everyColumnsAreNull = itemsInView.every(
            (field) => item[field] === null || item[field] === '' || item[field] === undefined,
          );
          if (!everyColumnsAreNull) {
            this.isEditDataTable = true;
            return true;
          }
        });
      }, 100)
    },
    updateOrganization(data) {
      const { rowData, value } = data
      rowData.organizational_division = this.getObjOrigination[value]?.id
    },
    handleChangeTextToIdInSpecialPattern(rowData, binding, value) {
      const data = {rowData, binding, value}

      if(binding === 'organizational_division') { //update id for organizational_division
        this.updateOrganization(data);
        this.checkTableChangeData();
      }
    },
    preprocessPayloadData(item) {
      let payload = {
        id: item?.id,
        organizational_division: item.organizational_division,
        company_name: item.company_name?.trim(),
        business_name: item?.business_name?.trim() || null,
        country: item?.country?.trim() || null,
        layer_3: item?.layer_3?.trim() || null,
        layer_4: item?.layer_4?.trim() || null,
        layer_5: item?.layer_5?.trim() || null,
        layer_6: item?.layer_6?.trim() || null,
        contractor_id: this.currentUser.user.contractor_id,
        status: item?.status === null ? 1 : item?.status ? 1 : 0,
      }
      if (item?.id === BLANK_ID) {
        delete payload.id;
        payload.contractor_id = null;
      }
      return payload;
    },
    trimTextBeforeAddToTable(item) {
      item['company_name'] = item['company_name']?.trim();
      item['business_name'] = item['business_name']?.trim();
      item['country'] = item['country']?.trim();
      item['layer_3'] = item['layer_3']?.trim();
      item['layer_4'] = item['layer_4']?.trim();
      item['layer_5'] = item['layer_5']?.trim();
      item['layer_6'] = item['layer_6']?.trim();
    }
  },
};
</script>

<style scoped lang="scss">
@import './styles/index.scss';
</style>
<style lang="scss">
.add-layer {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 24px;
  height: 24px;
  background-image: url('../../assets/icons/facility/addLayer.svg');
  &:hover {
    cursor: pointer;
    background-image: url('../../assets/icons/facility/hoverLayer.svg');
  }
}
</style>
